import { baseApi } from '@/admin/baseApi';
import { t } from '@/core/localization';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
const api = baseApi.enhanceEndpoints({ addTagTypes: ['Locations'] }).injectEndpoints({
    // reducerPath: 'api/settings/location',
    endpoints: (builder) => ({
        getLocations: builder.query({
            query: () => ({
                method: 'GET',
                url: 'location',
            }),
            // SAME: providesTags: (result) => providesList(result, 'Locations', 'locationId'),
            providesTags: (result) => result
                ? [...result.map(({ id }) => ({ type: 'Locations', id })), { type: 'Locations', id: 'LIST' }, 'Locations']
                : [{ type: 'Locations', id: 'LIST' }],
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.locations.request.failed'), error }));
                }
            },
        }),
        getLocation: builder.query({
            query: (id) => ({
                method: 'GET',
                url: `location/${id}`,
            }),
            providesTags: (result, error, id) => [{ type: 'Locations', id }],
        }),
        addLocation: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `location`,
                body,
            }),
            invalidatesTags: ['Locations'],
        }),
        editLocation: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `location/${body.id}`,
                body,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Locations', id }],
        }),
        deleteLocation: builder.mutation({
            query: (locationId) => ({
                method: 'DELETE',
                url: `location/${locationId}`,
            }),
            // invalidatesTags: ['Location'],
            // TODO: CHECK if it is working correct and only a single row is updated! If not, just change id to locationId
            // everywhere, according to https://redux-toolkit.js.org/rtk-query/usage/automated-refetching
            invalidatesTags: (result, error, locationId) => [{ type: 'Locations', id: locationId }],
        }),
    }),
});
export { api as locationApi };
export const { useGetLocationsQuery, useGetLocationQuery, useAddLocationMutation, useEditLocationMutation, useDeleteLocationMutation, } = api;
